<template>
  <div>
    <template v-if="loadingCourse">
      <div class="preloader" style="display: flex;flex-direction: column;">
        <img src="/assets/images/logo.svg">
        <h2 class="text-white">Integrated Platform</h2>

        <div class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <main class="bg-grey">
        <section class="main__grid">
          <div class="container">
            <div>
              <aside class="module__section">
                <img
                  class="module__img"
                  :src="itemData.avatar"
                  :alt="itemData.title"
                  style="object-fit: cover;"
                >
                <template v-if="!joinedCourse">
                  <div class="module__details">
                    <span>Join this free class for full access.</span>
                    <button
                      class="btn__primary btn__primary--alt btn__grey--sm"
                      @click.prevent="joinCourse"
                    >Join</button>
                  </div>
                </template>
              </aside>

              <main class="courses__tabs module__tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      id="learn-tab"
                      data-toggle="tab"
                      href="#learn"
                      role="tab"
                      aria-controls="learn"
                      aria-selected="true"
                      @click="activateTab('learningTab')"
                    >Lessons</a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="discussion-tab"
                      data-toggle="tab"
                      href="#discussion"
                      role="tab"
                      aria-controls="discussion"
                      aria-selected="false"
                      @click="activateTab('discussionTab')"
                    >Discussion</a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="quiz-tab"
                      data-toggle="tab"
                      href="#quiz"
                      role="tab"
                      aria-controls="quiz"
                      aria-selected="false"
                      @click="activateTab('quizTab')"
                    >Take Assessment</a>
                  </li>
                  <!--<li class="nav-item">-->
                  <!--<a class="nav-link" id="content-tab" data-toggle="tab" href="#content" role="tab" aria-controls="content" aria-selected="false" @click="activateTab('contentTab')">Additional Content</a>-->
                  <!--</li>-->
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="learn"
                    role="tabpanel"
                    aria-labelledby="learn-tab"
                    ref="learningTab"
                  >
                    <template v-if="joinedCourse">
                      <div class="module__wrapper--flex">
                        <h4 class="bold">Introduction</h4>
                        <div class="module__body">
                          <p v-html="itemData.description"></p>
                        </div>
                      </div>

                      <div class="module__wrapper">
                        <span class="module__label">Lessons</span>
                        <template v-if="lessons && lessons.length > 0">
                          <ul>
                            <li v-for="lesson in lessons" :key="lesson.id" class>
                              <router-link
                                :to="{
																	name: 'course-lessons',
																	params: {
																		id: lesson.id,
																		onlineClassId: itemData.id
																	}
																}"
                                class="module__item"
                              >
                                <div>
                                  <h5 class="module__title">
                                    {{ lesson.title }}
                                    <template
                                            v-if="lesson.lessonProgress && lesson.lessonProgress.length > 0"
                                    >
                                      <span class="badge badge-primary">Completed</span>
                                    </template>
                                    <template v-else>
                                      <span class="badge badge-warning">Not Completed</span>
                                    </template>
                                  </h5>
                                  <span v-html="lesson.description"></span>
                                </div>
                                <div class="item__row">
                                  <a class="link__module" href>
                                    <svg
                                      width="9"
                                      height="17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M.4 14.4l5.3-5.9L.4 2.58A1.64 1.64 0 0 1 .4.44c.53-.59 1.4-.59 1.93 0L8.6 7.43c.53.6.53 1.55 0 2.14l-6.27 6.98c-.54.6-1.4.6-1.93 0a1.68 1.68 0 0 1 0-2.16z"
                                        fill="#4F4F4F"
                                      ></path>
                                    </svg>
                                  </a>
                                </div>
                              </router-link>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <h4 class="padded">Join this course to view content</h4>
                    </template>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="discussion"
                    role="tabpanel"
                    aria-labelledby="discussion-tab"
                    ref="discussionTab"
                  >
                    <template v-if="joinedCourse">
                      <course-discussion :joinedCourse="joinedCourse"/>
                    </template>
                    <template v-else>
                      <h4 class="padded">Join this course to participate in course discussion</h4>
                    </template>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="quiz"
                    role="tabpanel"
                    aria-labelledby="quiz-tab"
                    ref="quizTab"
                  >
                    <template v-if="joinedCourse">
                      <CourseQuiz :done="joinedCourse" :itemData="itemData"/>
                    </template>
                    <template v-else>
                      <h4 class="padded">Join this course to take a quiz</h4>
                    </template>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="content"
                    role="tabpanel"
                    aria-labelledby="content-tab"
                    ref="contentTab"
                  ></div>
                </div>
              </main>
            </div>
          </div>
        </section>
      </main>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  getCourse,
  getCourseLearner
} from "../../utils/api/course";
import { getUserProfile } from "../../utils/api/user";
import Loader from "../../components/Loader";
import CourseQuiz from "./CourseQuiz";
import CourseDiscussion from "./CourseDiscussion";
import setActiveTab from "../../utils/tabPanel";
import { success, fail } from "../../utils/toast";
import eventHub from '../../utils/eventhub';

export default {
  name: "CourseDetail",
  data() {
    return {
      loadingCourse: true,
      itemData: {},
      courseLoaded: false,
      lessons: [],
      userCourses: [],
      userCoursesLoaded: false,
      userId: this.$session.get("id"),
      agreementStatus: false,
      lessonIds: []
    };
  },
  created() {
    this.getCourse();
    this.courseLearner();
    this.getUserProfile();
    eventHub.$on('changed-instruction-status', (payload) => {
      this.agreementStatus = payload;
    });
  },

  methods: {
    ...mapMutations(["setJoinedCourse", "resetJoinedCourse",'setLessonIds']),
    courseLearner() {
      getCourseLearner(this.$route.params.id, this.$session.get('id'))
        .then((response) => {
          if (response.status === 200) {
            this.setJoinedCourse(!!response.data.data.class_id);
            return true;
          }
          this.resetJoinedCourse();
          return false;
        })
        .catch((error) => {
          this.resetJoinedCourse();
          return error;
        });
    },
    getCourse() {
      getCourse(this.$route.params.id, this.userId)
        .then((response) => {
          if (response.status === 200) {
            this.itemData = response.data.data;
            this.lessons = response.data.data.lessons;
            const lessonId = this.lessons.map(lesson => lesson.id);
            this.setLessonIds(lessonId);
            this.courseLoaded = true;
            return true;
          }
          this.courseLoaded = false;
          return false;
        }).catch((error) => {
        this.courseLoaded = false;
        return error;
      }).finally(() => {
        this.loadingCourse = false;
      });
    },
    activateTab(ref) {
      return setActiveTab(ref, this.$refs);
    },
    getUserProfile() {
      getUserProfile(this.userId)
        .then((response) => {
          if (response.status === 200) {
            this.userCourses = response.data.data.classes;
            this.userCoursesLoaded = true;
            const joinedId = this.userCourses.find(course => course.class_id === Number(this.$route.params.id)).class_id;
            if (joinedId) {
              this.setJoinedCourse(true);
            } else {
              this.resetJoinedCourse();
            }
          }
          this.userCoursesLoaded = false;
          return false;
        }).catch((error) => {
        this.userCoursesLoaded = false;
        return error;
      });
    }
  },

  computed: {
    ...mapGetters({
      joinedCourse: "getJoinedStatus",
      getLessonId:'getLessonIds'
    })
  },
  components: {
    Loader,
    CourseDiscussion,
    CourseQuiz
  },
  filters: {
    date(value) {
      return moment(value).fromNow();
    }
  }
};
</script>

<style lang="scss" scoped>
.div__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.btn__primary--alt {
  min-width: auto;
}
.forum__link {
  max-width: 100%;
}
.module {
  &__label {
    margin-left: 0;
  }
  &__item {
    &:hover {
      color: inherit;
    }
  }
}
.padded {
  padding: 30px;
}
</style>
